import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

import { Button, TYPE } from 'components/Button'
import { Col, Grid, GridGap } from 'components/Grid'
import { List, ListItem } from 'components/List'
import Section from 'components/Section'
import { SectionType, Size } from 'components/Section/Section'
import Style from 'components/Style'

interface BasicInfoProps {
  type?: SectionType
  nrItems?: number
  contentKeySlug?: string
  detailsScroll: () => void
  infoScroll: () => void
}

const BasicInfo: React.FC<BasicInfoProps> = props => {
  const renderItems = () => {
    const length = props.nrItems || 3
    const output = []
    for (let i = 1; i <= length; i++) {
      output.push(
        <ListItem key={i}>
          <DisplayContent
            addNode
            contentKey={`${i}-list-item${props.contentKeySlug || ''}`}
          >
            {`${i}-list-item`}
          </DisplayContent>
        </ListItem>,
      )
    }
    return output
  }

  return (
    <Section
      type={props.type || SectionType.transparentColor}
      size={Size.xs}
      noPadding
    >
      <Style margin={[[20, 0, 20, 0]]}>
        <DisplayContent addNode contentKey="blurb">
          There are so many places that you have not yet been, did you know
          that? Yes, of course you knew that, but we didn't! So tell us which
          cities in Europe you have seen. Not only is that great for us to know,
          but we can also send you straight away to a new city.
        </DisplayContent>
      </Style>
      <Style margin={[[0, 0, 20, 0]]}>
        <List isText>{renderItems()}</List>
      </Style>
      <Style margin={[[0, 0, 10, 0]]}>
        <Grid
          nrCols={[1, 2]}
          minContent
          colGap={[GridGap.m]}
          rowGap={[GridGap.m]}
        >
          <Col>
            <Button cutOff="none" onClick={props.detailsScroll}>
              <DisplayContent contentKey="cta-plan-trip" edit={true}>
                Stel trip samen
              </DisplayContent>
            </Button>
          </Col>
          <Col>
            <Button cutOff="none" type={TYPE.angel} onClick={props.infoScroll}>
              <DisplayContent contentKey="cta-know-more" edit={true}>
                Wat moet ik weten
              </DisplayContent>
            </Button>
          </Col>
        </Grid>
      </Style>
    </Section>
  )
}

export default BasicInfo
